import { receiveServerErrors } from "../Errors/errorActions";
import Cookies from "js-cookie";

export const RECEIVE_VIDEO_NOTES = "RECEIVE_VIDEO_NOTES";
export const RECEIVE_PRODUCT_NOTES = "RECEIVE_PRODUCT_NOTES";
export const RECEIVE_INFLUENCER_NOTES = "RECEIVE_INFLUENCER_NOTES";
export const RECEIVE_VIDEO_NOTE = "RECEIVE_VIDEO_NOTE";
export const RECEIVE_PRODUCT_NOTE = "RECEIVE_PRODUCT_NOTE";
export const RECEIVE_INFLUENCER_NOTE = "RECEIVE_INFLUENCER_NOTE";

const receiveNotes = (notes, type) => {
  switch (type) {
    case "video":
      return { type: RECEIVE_VIDEO_NOTES, notes };
    case "product":
      return { type: RECEIVE_PRODUCT_NOTES, notes };
    case "influencer":
      return { type: RECEIVE_INFLUENCER_NOTES, notes };
  }
};

const receiveNote = (note, type) => {
  switch (type) {
    case "video":
      return { type: RECEIVE_VIDEO_NOTE, note };
    case "product":
      return { type: RECEIVE_PRODUCT_NOTE, note };
    case "influencer":
      return { type: RECEIVE_INFLUENCER_NOTE, note };
  }
};

export const fetchNotes = (type) => (dispatch) => {
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/${type}_notes`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(notes) {
      dispatch(receiveNotes(notes, type));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchNote = (type, id) => (dispatch) => {
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/${type}s/${id}/${type}_note`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(notes) {
      dispatch(receiveNotes(notes, type));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const updateNote = (id, data, type) => (dispatch) => {
  $.ajax({
    method: "put",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/${type}s/${id}/${type}_note`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
      ...data,
    },
    success(note) {
      dispatch(receiveNote(note, type));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};
